export default __webpack_public_path__ + "static/media/SOLDADURAMUEBLE.a7c4fd7e.webp";